import { CoreApiResponse } from "../../libs/core-api-requests/common";
import AuthDataRequest from "../../libs/core-api-requests/service/authDataRequest";
import { IAuthDataF3BusRequestDTO, IAuthDataViewDTO } from "../../libs/coreapi-dto/service/authData";
import CoreApiService from "../../system/api/coreApiService";
import { DictionaryDataProvider } from "./Common";


export class AuthDataDataProvider extends DictionaryDataProvider<IAuthDataViewDTO, IAuthDataViewDTO> {
    private _coreApiService: CoreApiService;

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }

    getDataRequest(): Promise<AuthDataRequest> {
        return this._coreApiService.authDataRequest;
    }

    getServiceName(serviceName: string, callback?: (e: CoreApiResponse<IAuthDataViewDTO>) => void) {
        this.getDataRequest().then((r) =>
            r.getServiceName(serviceName, (e) => {
                if (e.respType === 'isCompleted') {
                    callback?.(e);
                } else {
                    callback?.(e)
                }
            },
            )
        );
    }

    getClientName(clientName: string, callback?: (e: CoreApiResponse<IAuthDataViewDTO>) => void) {
        this.getDataRequest().then((request) => request.getClientName(clientName, callback));
    }

    createF3Bus(body: IAuthDataF3BusRequestDTO, callback?: (ids: string[]) => void) {
        this.getDataRequest().then((request) =>
            request.createF3Bus(body, (response) => {
                if (response.respType === 'isCompleted') {
                    callback?.(response.data);
                }
            }),
        );
    }

}
